"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuTxtHeader = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const ToolbarMenu_1 = require("@jsonjoy.com/ui/lib/4-card/Toolbar/ToolbarMenu");
const AutoExpandableToolbar_1 = require("@jsonjoy.com/ui/lib/4-card/Toolbar/ToolbarMenu/AutoExpandableToolbar");
const ToolbarSep_1 = require("@jsonjoy.com/ui/lib/4-card/Toolbar/ToolbarSep");
const Split_1 = require("@jsonjoy.com/ui/lib/3-list-item/Split");
const DocumentOutlineButton_1 = require("../../chrome/DocumentOutlineButton");
const context_2 = require("../../context");
const ui_1 = require("@jsonjoy.com/ui");
const HEIGHT = 48;
const blockClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    pd: '0 32px',
    ai: 'center',
    h: HEIGHT + 'px',
    bxz: 'border-box',
    // Electron window dragging.
    '-webkit-app-region': 'drag',
    '& button, & a, & input, & textarea, & select, & [role="button"], & [role="tablist"], & [role="img"]': {
        '-webkit-app-region': 'no-drag',
    },
});
const toolbarContainerClass = (0, nano_theme_1.rule)({
    d: 'flex',
    fld: 'row',
    ai: 'center',
    h: HEIGHT + 'px',
});
const readTitlebarInsetPx = () => {
    if (typeof window === 'undefined' || !document.documentElement)
        return 0;
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--titlebar-inset-left').trim();
    return parseFloat(raw) || 0;
};
const MuTxtHeader = ({ editor }) => {
    const mutxt = (0, context_2.useMuTxt)();
    const availableWidth = mutxt.sizer.width.use();
    const desiredWidth = mutxt.sizer.content.use();
    const shellBox = mutxt.shellBox.use();
    const displayMode = mutxt.displayMode.use();
    const styles = (0, context_1.useStyles)();
    mutxt.version.use();
    // Needed to account correctly for Electron window traffic lights on Mac.
    const shellWidth = shellBox[2];
    const width = displayMode === 'fullscreen'
        ? shellWidth
        : displayMode === 'fullwindow'
            ? Math.max(0, shellWidth - readTitlebarInsetPx())
            : Math.min(availableWidth, desiredWidth);
    const basePad = width < 1200 ? 8 : 32;
    const paddingLeft = displayMode === 'fullwindow' ? `max(${basePad}px, var(--titlebar-inset-left, 0px))` : basePad;
    const inlineMenu = mutxt.inline.menu.buildToolbarMenu();
    const voidsMenu = mutxt.voids.menu.buildToolbarMenu();
    const blockMenu = mutxt.block.menu.buildToolbarMenu(width > 1300 ? 2 : width > 1200 ? 1 : 0);
    return (React.createElement(ui_1.SetNamedTrace, { name: 'subtle', value: true },
        React.createElement(Split_1.Split, { className: blockClass, style: {
                borderBottom: '1px solid ' + (styles.light ? styles.g(0, 0.08) : styles.g(0, 0.1)),
                paddingLeft,
                paddingRight: basePad,
            } },
            React.createElement("div", { className: toolbarContainerClass }, width > 900 ? (React.createElement(React.Fragment, null,
                React.createElement(ToolbarMenu_1.ToolbarMenu, { menu: inlineMenu, pane: { transparent: true, inline: true } }),
                React.createElement(ToolbarSep_1.ToolbarSep, null),
                React.createElement(ToolbarSep_1.ToolbarSep, { line: true, height: HEIGHT - 1, lite: true }),
                React.createElement(ToolbarSep_1.ToolbarSep, null),
                React.createElement(ToolbarMenu_1.ToolbarMenu, { menu: voidsMenu, pane: { transparent: true, inline: true } }),
                React.createElement(ToolbarSep_1.ToolbarSep, { line: true, height: HEIGHT - 1, lite: true }),
                React.createElement(ToolbarSep_1.ToolbarSep, null),
                React.createElement(AutoExpandableToolbar_1.AutoExpandableToolbar, { menu: blockMenu, pane: { transparent: true, inline: true }, more: { small: true } }))) : (React.createElement(AutoExpandableToolbar_1.AutoExpandableToolbar, { maxWidth: width * 0.6, menu: {
                    ...inlineMenu,
                    maxToolbarItems: inlineMenu.maxToolbarItems || inlineMenu.children.length,
                    minWidth: 288,
                    children: [
                        ...inlineMenu.children,
                        { name: 'sep-voids', sep: true },
                        ...voidsMenu.children,
                        { name: 'sep-blocks', sep: true },
                        ...blockMenu.children,
                    ],
                }, pane: { transparent: true, inline: true }, more: { small: true } }))),
            React.createElement("div", { className: toolbarContainerClass },
                React.createElement(DocumentOutlineButton_1.DocumentOutlineButton, { editor: editor, contentWidth: 300 }),
                React.createElement(ToolbarSep_1.ToolbarSep, { line: true }),
                React.createElement(ToolbarMenu_1.ToolbarMenu, { pane: { transparent: true, inline: true }, menu: mutxt.docMenu.buildHeaderToolbar(width > 1500 ? 5 : width > 1400 ? 4 : width > 1300 ? 3 : width > 1200 ? 2 : width > 1100 ? 1 : 0) })))));
};
exports.MuTxtHeader = MuTxtHeader;
